var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelledCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#EE2336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7.5H20C21.6569 7.5 23 8.84315 23 10.5V19.5C23 21.1569 21.6569 22.5 20 22.5H11C9.34315 22.5 8 21.1569 8 19.5V10.5C8 8.84315 9.34315 7.5 11 7.5ZM18.11 17.61C18.3293 17.3904 18.3293 17.0346 18.11 16.815L16.295 15L18.11 13.185C18.3165 12.9634 18.3104 12.618 18.0962 12.4038C17.882 12.1896 17.5366 12.1835 17.315 12.39L15.5 14.205L13.685 12.39C13.4634 12.1835 13.118 12.1896 12.9038 12.4038C12.6896 12.618 12.6835 12.9634 12.89 13.185L14.705 15L12.89 16.815C12.6707 17.0346 12.6707 17.3904 12.89 17.61C12.9971 17.7129 13.139 17.7718 13.2875 17.775C13.4363 17.7733 13.5787 17.7142 13.685 17.61L15.5 15.795L17.315 17.61C17.4213 17.7142 17.5637 17.7733 17.7125 17.775C17.861 17.7718 18.0029 17.7129 18.11 17.61Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledCard);
export default __webpack_public_path__ + "static/media/CancelledCard.8ad6ac2056d1b14edac87cafe6688da6.svg";
export { ForwardRef as ReactComponent };